import { Base64 } from 'js-base64'

export default {
  /**
   * 设置缓存数据
   **/
  setCache (key, value, days) {
    // 设置过期原则
    if (!value) {
      return localStorage.removeItem(Base64.encode(key))
    }
    const Days = days || (365 * 100) // 默认保留100年
    const exp = new Date()
    localStorage.setItem(Base64.encode(key), Base64.encode(JSON.stringify({
      value: value,
      expires: exp.getTime() + Days * 24 * 60 * 60 * 1000
    })))
  },
  /**
   * 获取缓存数据
   **/
  getCache (name) {
    try {
      if (localStorage.getItem(Base64.encode(name)) == null) {
        return null
      }
      let o = JSON.parse(Base64.decode(localStorage.getItem(Base64.encode(name))))
      if (!o || o.expires < Date.now()) {
        localStorage.removeItem(Base64.encode(name))
        return null
      } else {
        return o.value
      }
    } catch (e) {
      return Base64.decode(localStorage.getItem(Base64.encode(name)))
    } finally {
    }
  },
  removeCache (name) {
    return this.setCache(name, null)
  },
  getSession: function (sKey) {
    const value = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null
    if (value) {
      if (value.indexOf('{') === 0 || value.indexOf('[') === 0) {
        return JSON.parse(value)
      } else {
        return value
      }
    }
    return null
  },
  setSession: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
      return false
    }
    var sExpires = ''
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd
          break
        case String:
          sExpires = '; expires=' + vEnd
          break
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString()
          break
      }
    }
    if (typeof sValue === 'object') {
      sValue = JSON.stringify(sValue)
    }
    document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '')
    return true
  },
  removeSession: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasSession(sKey)) {
      return false
    }
    document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '')
    return true
  },
  hasSession: function (sKey) {
    return (new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=')).test(document.cookie)
  },
  keys: /* optional method: you can safely remove it! */ function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:=[^;]*)?;\s*/)
    for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx])
    }
    return aKeys
  }
}
